import React, { lazy } from 'react'

import RequireAuthentication from '@/router/guards/RequireAuthentication'

const MedicalSpecialities = lazy(
  () => import('@/modules/MedicalSpecialities/pages'),
)

const MedicalServicesDisabledPage = lazy(
  () =>
    import('@/modules/MedicalSpecialities/pages/MedicalServicesDisabledPage'),
)
const UserDataPageWithoutScreening = lazy(
  () =>
    import(
      '@/modules/MedicalSpecialities/pages/UserDataPageWithoutScreening/index'
    ),
)
const MedicalSpecialitiesRoutes = [
  <RequireAuthentication
    path="/"
    key="/"
    exact
    component={MedicalSpecialities}
  />,
  <RequireAuthentication
    path="/atualizar-dados"
    key="/atualizar-dados"
    exact
    component={UserDataPageWithoutScreening}
  />,
  <RequireAuthentication
    path="/solicite-agendamento"
    key="/solicite-agendamento"
    exact
    component={MedicalServicesDisabledPage}
  />,
]

export default MedicalSpecialitiesRoutes
